import React from "react";

function Rain() {
  return (
    <div className="behind-image">
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
      <i className="rain-animation"></i>
    </div>
  );
}

export default Rain;
